import Vue from 'vue';
import successTickIcon from '@/assets/images/success-tick-icon.png';

const state = {
  type: null,
  position: null,
  title: null,
  text: null
};

const actions = {
  success({ commit }, { showType, position, title, text }) {
    commit('success', { showType, position, title, text });
  },
  info({ commit }, { showType, position, title, text }) {
    commit('info', { showType, position, title, text });
  },
  error({ commit }, { showType, position, title, text }) {
    commit('error', { showType, position, title, text });
  },
  setMessage({ commit }, { type, message }) {
    commit('setMessage', { type, message });
  },
  clear({ commit }) {
    commit('clear');
  }
};

const getters = {
  errorMessages: state => {
    if (state.type === 'error' && state.text !== '') {
      return state.text;
    }
    return '';
  },
  successMessages: state => {
    if (state.type === 'success' && state.text !== '') {
      return state.text;
    }
    return '';
  }
};

const isAppDarkMode = () => localStorage.getItem('darkMode') === 'true';

const resolveSuccessTitle = title => {
  if (title === null || title === undefined || String(title).trim() === '') {
    return 'Successful';
  }
  return title;
};

const displayToast = ({ type, position, title, text }) => {
  const isSuccess = type === 'success';
  const isError = type === 'error';
  const options = {
    toast: true,
    position,
    showConfirmButton: false,
    timer: 3000,
    type,
    icon: type,
    title: isSuccess ? resolveSuccessTitle(title) : title,
    text
  };

  if (isSuccess) {
    options.customClass = {
      popup: isAppDarkMode() ? 'success-modal success-modal--dark' : 'success-modal',
      title: 'success-modal__title',
      htmlContainer: 'success-modal__text',
      icon: 'success-modal__icon-wrap'
    };
    options.iconHtml = `<img src="${successTickIcon}" alt="" class="success-modal__icon" />`;
  }

  if (isError) {
    options.customClass = {
      popup: isAppDarkMode() ? 'success-modal success-modal--dark error-modal' : 'success-modal error-modal',
      title: 'success-modal__title',
      htmlContainer: 'success-modal__text',
      icon: 'success-modal__icon-wrap error-modal__icon-wrap'
    };
  }

  Vue.swal(options);
};

const displayDialog = ({ type, position, title, text }) => {
  const isDark = isAppDarkMode();
  const isError = type === 'error';
  const popupClasses = [];
  if (isError) {
    popupClasses.push('error-modal');
  }
  // Reuse existing upload-modal--dark for dialog surface/border (admin-upload-modal.css)
  if (isDark) {
    popupClasses.push('upload-modal--dark');
  }
  Vue.swal({
    position,
    showConfirmButton: true,
    type,
    icon: type,
    title,
    text,
    background: isDark ? '#172033' : '#ffffff',
    customClass: {
      popup: popupClasses.join(' '),
      title: isDark ? 'text-light' : 'text-dark',
      htmlContainer: isDark ? 'text-light' : 'text-dark',
      content: isDark ? 'text-light' : 'text-dark',
      icon: isError ? 'error-modal__icon-wrap' : ''
    }
  });
};

const mutations = {
  success(state, { showType, position, title, text }) {
    state.type = 'success';
    state.position = position;
    state.title = title;
    state.text = text;
    if (showType === 'toast') {
      displayToast({ type: state.type, position: state.position, title: state.title, text: state.text });
    }
    if (showType === 'dialog') {
      displayDialog({ type: state.type, position: state.position, title: state.title, text: state.text });
    }
  },
  info(state, { showType, position, title, text }) {
    state.type = 'info';
    state.position = position;
    state.title = title;
    state.text = text;
    if (showType === 'toast') {
      displayToast({ type: state.type, position: state.position, title: state.title, text: state.text });
    }
    if (showType === 'dialog') {
      displayDialog({ type: state.type, position: state.position, title: state.title, text: state.text });
    }
  },
  error(state, { showType, position, title, text }) {
    state.type = 'error';
    state.position = position;
    state.title = title;
    state.text = text;
    if (showType === 'toast') {
      displayToast({ type: state.type, position: state.position, title: state.title, text: state.text });
    }
    if (showType === 'dialog') {
      displayDialog({ type: state.type, position: state.position, title: state.title, text: state.text });
    }
  },
  clear(state) {
    state.type = null;
    state.position = null;
    state.title = null;
    state.text = null;
  },
  setMessage(state, { type, message }) {
    state.type = type;
    state.text = message;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
